<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => this.$router.go(-1)"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Registrar Plano de Intervenção Psicopedagógico - PIP
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <!-- Seção 1: Identificação do Aluno -->
        <v-card class="mb-4">
          <v-card-title>1. Identificação do Aluno</v-card-title>
          <v-card-text>
            <h4>
              Aluno(a): {{ matricula && matricula.aluno ? matricula.aluno.nomecompleto : "- - -" }}
            </h4>
            <h4>
              Data de Nascimento:
              {{
                matricula?.aluno?.data_nascimento
                  ? new Date(matricula.aluno.data_nascimento + "T00:00:00").toLocaleDateString(
                      "pt-BR"
                    )
                  : "- - -"
              }}
            </h4>
            <h4>
              Escola:
              {{
                gestao && gestao.turma && gestao.turma.franquia
                  ? gestao.turma.franquia.descricao
                  : "- - -"
              }}
            </h4>
            <h4>
              Etapa:
              {{ matricula?.serie ? matricula?.serie.descricao : "..." }}
            </h4>
            <h4>
              Profissional: {{ gestao && gestao.profissional ? gestao.profissional.name : "- - -" }}
            </h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12 text-center" class="pt-0 pb-4">
        <v-toolbar flat>
          <v-tabs dark v-model="form.bimestre" background-color="primary" grow>
            <v-tab
              v-for="item of $constants.bimestres"
              :key="item.value"
              @click="() => loadData(item.value)"
            >
              <v-badge v-if="form.bimestre === item.value" color="success" dot overlap>
                {{ item.desc }}
              </v-badge>
              <div v-else>{{ item.desc }}</div>
            </v-tab>
          </v-tabs>
        </v-toolbar>
      </v-col>
    </v-row>

    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(salvar)" :disabled="submittingForm">
        <!-- Seção 2: Queixa Principal -->
        <v-card class="mb-4">
          <v-card-title>2. Queixa Principal</v-card-title>
          <v-card-text>
            <ValidationProvider
              name="Queixa Principal"
              :rules="{ max_chars: 2000, no_special_chars: true, required: true }"
              v-slot="{ errors }"
            >
              <v-textarea
                v-model="form.queixa_principal"
                solo
                rows="5"
                :error-messages="errors"
                counter="2000"
                maxlength="2000"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <!-- Seção 3: Hipótese Diagnóstica -->
        <v-card class="mb-4">
          <v-card-title>3. Hipótese Diagnóstica</v-card-title>
          <v-card-text>
            <ValidationProvider
              name="Hipótese Diagnóstica"
              :rules="{ max_chars: 2000, no_special_chars: true, required: true }"
              v-slot="{ errors }"
            >
              <v-textarea
                v-model="form.hipotese_diagnostica"
                solo
                rows="5"
                :error-messages="errors"
                counter="2000"
                maxlength="2000"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <!-- Seção 4: Objetivos da Intervenção -->
        <v-card class="mb-4">
          <v-card-title>4. Objetivos da Intervenção</v-card-title>
          <v-card-text>
            <ValidationProvider
              name="Objetivos da Intervenção"
              :rules="{ max_chars: 2000, no_special_chars: true, required: true }"
              v-slot="{ errors }"
            >
              <v-textarea
                v-model="form.objetivos_intervencao"
                solo
                rows="4"
                class="mb-4"
                :error-messages="errors"
                counter="2000"
                maxlength="2000"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <!-- Seção 5: Plano de Intervenção e Estratégia -->
        <v-card class="mb-4">
          <v-card-title>5. Plano de Intervenção e Estratégia</v-card-title>
          <v-simple-table class="mb-4" style="border: 1px solid #e0e0e0">
            <thead>
              <tr>
                <th style="width: 18%; background-color: #e8e8d8">Área</th>
                <th style="width: 27%; background-color: #e8e8d8">Objetivo Específico</th>
                <th style="width: 27%; background-color: #e8e8d8">Sugestão de Atividades</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="area in form.areas_desenvolvimento" :key="area.area">
                <td style="font-weight: bold; vertical-align: middle">{{ area.area }}</td>
                <td>
                  <ValidationProvider
                    :name="`Objetivo Específico (${area.area})`"
                    :rules="{ max_chars: 250, no_special_chars: true, required: true }"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      v-model="area.objetivo_especifico"
                      solo
                      dense
                      rows="4"
                      :error-messages="errors"
                      counter="250"
                      maxlength="250"
                      class="py-4"
                      no-resize
                    ></v-textarea>
                  </ValidationProvider>
                </td>
                <td>
                  <ValidationProvider
                    :name="`Sugestão de Atividades (${area.area})`"
                    :rules="{ max_chars: 250, no_special_chars: true, required: true }"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      v-model="area.sugestao_atividades"
                      solo
                      dense
                      rows="4"
                      :error-messages="errors"
                      counter="250"
                      maxlength="250"
                      class="py-4"
                      no-resize
                    ></v-textarea>
                  </ValidationProvider>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>

        <!-- Seção 6: Recursos de Materiais -->
        <v-card class="mb-4">
          <v-card-title>6. Recursos de Materiais</v-card-title>
          <v-card-text>
            <ValidationProvider
              name="Recursos de Materiais"
              :rules="{ max_chars: 2000, no_special_chars: true, required: true }"
              v-slot="{ errors }"
            >
              <v-textarea
                v-model="form.recursos_de_materiais"
                solo
                rows="5"
                :error-messages="errors"
                counter="2000"
                maxlength="2000"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <!-- Seção 7: Avaliação e Acompanhamento -->
        <v-card class="mb-4">
          <v-card-title>7. Avaliação e Acompanhamento</v-card-title>
          <v-card-text>
            <ValidationProvider
              name="Avaliação e Acompanhamento"
              :rules="{ max_chars: 2000, no_special_chars: true, required: true }"
              v-slot="{ errors }"
            >
              <v-textarea
                v-model="form.avaliacao_acompanhamento"
                solo
                rows="5"
                :error-messages="errors"
                counter="2000"
                maxlength="2000"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <!-- Observações 8: Observações -->
        <v-card class="mb-4">
          <v-card-title>8. Observações</v-card-title>
          <v-card-text>
            <ValidationProvider
              name="Observações"
              :rules="{ max_chars: 2000, no_special_chars: true }"
              v-slot="{ errors }"
            >
              <v-textarea
                v-model="form.observacoes"
                solo
                rows="5"
                :error-messages="errors"
                counter="2000"
                maxlength="2000"
              ></v-textarea>
            </ValidationProvider>
          </v-card-text>
        </v-card>

        <!-- Botões -->
        <v-col cols="12" class="mt-2">
          <v-row>
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              class="mr-3"
              lg
              block
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      submittingForm: false,
      fichaExiste: false,
      gestao: null,
      matricula: null,
      form: {
        bimestre: 0,
        queixa_principal: "",
        hipotese_diagnostica: "",
        objetivos_intervencao: "",
        recursos_de_materiais: "",
        avaliacao_acompanhamento: "",
        observacoes: "",
        areas_desenvolvimento: [
          { area: "Cognitiva", objetivo_especifico: "", sugestao_atividades: "" },
          { area: "Pedagógica", objetivo_especifico: "", sugestao_atividades: "" },
          { area: "Socioafetiva", objetivo_especifico: "", sugestao_atividades: "" },
          { area: "Coordenação Motora", objetivo_especifico: "", sugestao_atividades: "" },
        ],
      },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData(bimestre = null) {
      this.$loaderService.open("Carregando dados...");
      try {
        const { matricula_id, gestaoDeAulasId } = this.$route.params;
        const b = bimestre !== null ? bimestre : this.form.bimestre;

        const response = await this.$services.educacaoInclusivaService.carregarPlanoCAEE(
          matricula_id,
          gestaoDeAulasId,
          b
        );
        this.matricula = response.matricula;
        this.gestao = response.gestao;
        this.form.bimestre = b;

        if (response.ficha) {
          this.fichaExiste = true;
          const f = response.ficha;

          this.form.queixa_principal = f.queixa_principal || "";
          this.form.hipotese_diagnostica = f.hipotese_diagnostica || "";
          this.form.objetivos_intervencao = f.objetivos_intervencao || "";
          this.form.recursos_de_materiais = f.recursos_de_materiais || "";
          this.form.avaliacao_acompanhamento = f.avaliacao_acompanhamento || "";
          this.form.observacoes = f.observacoes || "";

          if (f.areas_desenvolvimento && f.areas_desenvolvimento.length > 0) {
            this.form.areas_desenvolvimento = f.areas_desenvolvimento;
          }
        } else {
          this.fichaExiste = false;
          this.form.queixa_principal = "";
          this.form.hipotese_diagnostica = "";
          this.form.objetivos_intervencao = "";
          this.form.recursos_de_materiais = "";
          this.form.avaliacao_acompanhamento = "";
          this.form.observacoes = "";
          this.form.areas_desenvolvimento = [
            { area: "Cognitiva", objetivo_especifico: "", sugestao_atividades: "" },
            { area: "Pedagógica", objetivo_especifico: "", sugestao_atividades: "" },
            { area: "Socioafetiva", objetivo_especifico: "", sugestao_atividades: "" },
            { area: "Coordenação Motora", objetivo_especifico: "", sugestao_atividades: "" },
          ];
        }

        if (this.$refs.observer) {
          this.$refs.observer.reset();
        }
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async salvar() {
      this.submittingForm = true;
      try {
        const { matricula_id, gestaoDeAulasId } = this.$route.params;
        const payload = {
          ...this.form,
          matricula_id,
          gestao_id: gestaoDeAulasId,
        };
        await this.$services.educacaoInclusivaService.salvarPlanoCAEE(payload);
        this.$toast.success("PIP salvo com sucesso!");
        this.fichaExiste = true;
      } catch (error) {
        this.$handleError(error);
      }
      this.submittingForm = false;
    },
  },
};
</script>

<style scoped></style>
